import React, { useEffect } from 'react';
import { Heart, ArrowLeft, ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function TermsPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="terms-page" data-testid="terms-page">
      <div className="container terms-wrap">
        <Link to="/" className="terms-back" data-testid="terms-back-link"><ArrowLeft size={15} /> Back to Krysha</Link>
        <div className="al-logo" style={{ marginTop: 18 }}><Heart size={24} fill="var(--red)" color="var(--red)" /> Krysha</div>
        <h1>Terms &amp; Refund Policy</h1>
        <p className="terms-updated">Krysha — A Love Station With Your Vibe</p>

        <h2>1. The Service</h2>
        <p>Krysha Love Station is a personalized matchmaking service. You fill one detailed form about your personality, lifestyle and preferences, choose a plan, and our team reviews your answers to identify compatible matches. Match contact details are shared privately on your preferred channel (WhatsApp, Email or Instagram). Krysha is not a swipe-based dating app and does not guarantee a relationship outcome.</p>

        <h2>2. Plans</h2>
        <p>Single Signal (₹99) includes 1 curated match. Triple Tune (₹199) includes 3 curated matches. All Access (₹999) includes unlimited matches for 1 year. Matches are provided as compatible profiles are identified; timing may vary with member availability.</p>

        <h2>3. 1 Month Match Guarantee &amp; Refunds</h2>
        <p>If we are unable to provide you a suitable match within 1 month (30 days) of your submission, you are eligible for a refund of the amount paid, minus a 10% service/processing charge. For example, on the ₹199 plan the refund amount is ₹179.10.</p>
        <p>To request a refund, contact us on the details you provided at submission or write to hello@krysha.love within a reasonable time after your 30-day window ends. Refunds are made to the original payment method. The guarantee applies once per submission and does not apply if a suitable match has already been shared with you within the window.</p>

        <h2>4. Privacy</h2>
        <p>Your form answers and contact details are used only for matchmaking. We never sell your data, and your contact details are shared only with a match, on your preferred channel, as part of the service. Example profiles shown on our website use AI-generated images and illustrative details to protect real members' identity.</p>

        <h2>5. Fair Use</h2>
        <p>Please provide honest, accurate information in your matchmaking form — matches are only as good as the answers behind them. We may decline or refund submissions containing false, offensive or misleading information.</p>

        <div className="terms-note"><ShieldCheck size={16} /> Questions about these terms? Write to hello@krysha.love.</div>
      </div>
    </div>
  );
}
